import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys, LIVE_REFETCH_MS } from "@/api/queryClient";
import type { WorkspaceSyncStatus } from "@/types";

// #229: voller Workspace-Sync-Status eines Agents (Device-ID, Relay, freigeschaltete
// Geräte, Live-Verbindung). Live-Polling, damit "verbunden?" aktuell bleibt.
export function useWorkspaceSync(agentId: string | undefined): UseQueryResult<WorkspaceSyncStatus> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: agentId
      ? queryKeys.subResource("agents", agentId, "workspace-sync")
      : ["resources", "agents", "_invalid", "workspace-sync"],
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<WorkspaceSyncStatus>(`/agents/${agentId}/workspace/sync`);
    },
    enabled: !!agentId && !!session,
    refetchInterval: LIVE_REFETCH_MS,
  });
}
